"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("./http");
// import CrossStorage from "./CrossStorage";
const launch_1 = require("./launch");
const token_1 = require("./http/token");
exports.default = {
    http: http_1.default,
    init: launch_1.default,
    setToken: token_1.setToken,
    getToken: token_1.getToken
};
